import numbers, { type NumberFormat as NF } from "@subly/s1/core/numbers";

export type NumberFormat = NF;

export default {
	...numbers
};